export const QUERY_KEYS = {
  // Auth / Org
  GOOGLE_LOGIN: ["google-login"],
  GOOGLE_SIGNUP: ["google-signup"],
  ACCEPT_INVITE: ["accept-invite"],
  CREATE_ORGANIZATION: "CREATE_ORGANIZATION",
  CREATE_ORGANIZATION_SIGNUP: "create-organization-signup",
  SEND_INVITE: ["SEND_INVITE"],
  USER_LOGIN: ["USER_LOGIN"],

  COMMENTS: "comments",
  VERIFY_OTP: "verify-otp",
  RESEND_OTP: "resend-otp",

  // User Management
  GET_ORG_USERS: ["GET_ORG_USERS"],
  GET_USER_STATS: ["GET_USER_STATS"],
  CURRENT_USER_DETAILS: ["CURRENT_USER_DETAILS"],
  GET_CURRENT_USER_PROFILE: ["GET_CURRENT_USER_PROFILE"],

  // Projects
  PROJECTS: (userUuid?: string) =>
    userUuid ? ["projects", userUuid] : ["projects"],
  PROJECT: (projectUuid?: string) => ["project", projectUuid],
  PROJECT_MEMBERS: (orgUuid?: string) => ["project-members", orgUuid],
  PROJECT_OWNERS: (orgUuid?: string) => ["project-owners", orgUuid],
  PROJECT_LABELS: (projectUuid?: string) => ["project-labels", projectUuid],

  // Project Defaults (work types, statuses etc.)
  PROJECT_DEFAULTS: (projectUuid?: string) => ["project-default", projectUuid],

  // Tasks / Work Items
  TASKS: (projectUuid?: string) =>
    projectUuid ? ["tasks", projectUuid] : ["tasks"],
  TASK: (projectUuid?: string, workItemUuid?: string) => [
    "task",
    projectUuid,
    workItemUuid,
  ],
  RESOLVE_PROJECT: (orgSlug: string, projectKey: string) => [
    "resolve-project",
    orgSlug,
    projectKey,
  ],
  RESOLVE_WORK_ITEM: (
    orgSlug: string,
    projectKey: string,
    workItemKey: string,
  ) => ["resolve-work-item", orgSlug, projectKey, workItemKey],

  // Location
  COUNTRIES: ["COUNTRIES"],

  // Smart Link
  URL_METADATA: (url: string) => ['url-metadata', url],

  // Comment Replies
  COMMENT_REPLIES: (
    projectUuid: string,
    workItemUuid: string,
    commentUuid: string,
  ) => ['comment-replies', projectUuid, workItemUuid, commentUuid],

  // Notifications — PMO
  NOTIFICATIONS: ['notifications'],
  NOTIFICATIONS_UNREAD_COUNT: ['notifications-unread-count'],

  // Notifications — HRM
  HRM_NOTIFICATIONS: ['hrm-notifications'],
  HRM_NOTIFICATIONS_UNREAD_COUNT: ['hrm-notifications-unread-count'],

  // HRMS
  HRMS_COUNTRIES: ['HRMS_COUNTRIES'],
  MY_PROFILE_STATUS: ['MY_PROFILE_STATUS'],
  PROFILE_STATUS: (appUserUuid?: string) => ['PROFILE_STATUS', appUserUuid],
  PROFILE_REVIEW: ['PROFILE_REVIEW'],
  HRMS_IDENTITY_DOCUMENTS_DRAFT: ['HRMS_IDENTITY_DOCUMENTS_DRAFT'],
  HRMS_MY_PERSONAL_DETAILS: ['HRMS_MY_PERSONAL_DETAILS'],
  HRMS_PERSONAL_DETAILS_DRAFT: ['HRMS_PERSONAL_DETAILS_DRAFT'],
  HRMS_MY_IDENTITY_DOCUMENTS: ['HRMS_MY_IDENTITY_DOCUMENTS'],
  HRMS_USER_IDENTITY_DOCUMENTS: (appUserUuid?: string) => ['HRMS_USER_IDENTITY_DOCUMENTS', appUserUuid],
  HRMS_MY_EDUCATIONAL_DETAILS: ['HRMS_MY_EDUCATIONAL_DETAILS'],
  HRMS_MY_WORK_EXPERIENCE: ['HRMS_MY_WORK_EXPERIENCE'],
  ATTENDANCE_TODAY_STATUS: ['ATTENDANCE_TODAY_STATUS'],
  ATTENDANCE_MONTHLY_SUMMARY: (startDate?: string, endDate?: string) => ['ATTENDANCE_MONTHLY_SUMMARY', startDate, endDate],
  ATTENDANCE_CALENDAR_HOVERS: (startDate?: string, endDate?: string) => ['ATTENDANCE_CALENDAR_HOVERS', startDate, endDate],
  ATTENDANCE_DAY_SUMMARY: (attendanceDate?: string) => ['ATTENDANCE_DAY_SUMMARY', attendanceDate],
  EMPLOYEES_ATTENDANCE: (params?: object) => ['EMPLOYEES_ATTENDANCE', params],



  // Global Search
  GLOBAL_SEARCH: (query: string, projectUuid?: string) =>
    ['global-search', query, projectUuid ?? ''],
  RECENTLY_VIEWED: (projectUuid?: string) => ['recently-viewed', projectUuid ?? ''],

  // Profile Tracker
  PROFILE_TRACKER_LIST: ['PROFILE_TRACKER_LIST'],
  PROFILE_REVIEW_STATUS: (appUserUuid?: string) => ['PROFILE_REVIEW_STATUS', appUserUuid],

  // PMO Reports
  PMO_UTILIZATION_LIST: (params?: object) => ['pmo-utilization-list', params],
  PMO_EMPLOYEE_SUMMARY: (appUserUuid?: string, params?: object) => ['pmo-employee-summary', appUserUuid, params],
  PMO_EMPLOYEE_KPIS: (appUserUuid?: string) => ['pmo-employee-kpis', appUserUuid],
  PMO_EMPLOYEE_WORK_ITEMS: (appUserUuid?: string, params?: object) => ['pmo-employee-work-items', appUserUuid, params],

  // PMO Team Insights
  PMO_TEAM_INSIGHTS: (params?: object) => ['pmo-team-insights', params],
  PMO_TEAM_INSIGHTS_MEMBER: (appUserUuid?: string, params?: object) => ['pmo-team-insights-member', appUserUuid, params],
  PMO_TEAM_INSIGHTS_WORK_LOG: (appUserUuid?: string, params?: object) => ['pmo-team-insights-work-log', appUserUuid, params],
  PMO_TEAM_INSIGHTS_ACTIVITY: (appUserUuid?: string, params?: object) => ['pmo-team-insights-activity', appUserUuid, params],

  // PMO Work Schedule
  PMO_WORK_SCHEDULE: ['pmo-work-schedule'],

  // PMO Member Availability — the bare keys match every search / member, for invalidation.
  PMO_MEMBERS_ALL: ['pmo-capacity-members'],
  PMO_MEMBERS: (params?: object) => ['pmo-capacity-members', params],
  PMO_MEMBER_ALL: ['pmo-capacity-member'],
  PMO_MEMBER: (appUserUuid?: string) => ['pmo-capacity-member', appUserUuid],
  PMO_MEMBER_HRM_ELIGIBILITY: (appUserUuid?: string) => ['pmo-capacity-member-hrm-eligibility', appUserUuid],

  // PMO Holiday Calendars — the bare keys match every year / calendar, for invalidation.
  PMO_HOLIDAY_CALENDARS_ALL: ['pmo-holiday-calendars'],
  PMO_HOLIDAY_CALENDARS: (year?: number) => ['pmo-holiday-calendars', year],
  PMO_HOLIDAYS_ALL: ['pmo-holidays'],
  PMO_HOLIDAYS: (calendarUuid?: string, year?: number) => ['pmo-holidays', calendarUuid, year],

  // PMO Convert to Scrum
  PMO_CONVERT_TO_SCRUM_CHECK: (projectUuid?: string) => ['pmo-convert-to-scrum-check', projectUuid],

};
